import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./auth/_guards";
import { EstudanteComponent } from "./pages/cadastro/estudante/estudante.component";
import { ComplementoEstudante } from "models/complemento-estudante";
import { ConfirmadoCadastroEstudanteComponent } from "./pages/cadastro/confirmado-cadastro-estudante/confirmado-cadastro-estudante.component";
import { ComplementoEstudanteComponent } from "./pages/cadastro/complemento-estudante/complemento-estudante.component";
import { ValidarCertificadoComponent } from "./pages/certificados/validacao-certificado/validar-certificado.component";

const routes: Routes = [
    // Padrão para telas com base no perfil
    // { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    {
        path: "login",
        loadChildren: () => import("./modules/login/login.module").then(m => m.LoginModule),
    },
    {
        path: "cadastro-do-estudante",
        component: EstudanteComponent,
    },
    {
        path: "confirmado-cadastro-estudante",
        component: ConfirmadoCadastroEstudanteComponent,
    },
    {
        path: "complemento-cadastro-estudante/:id",
        component: ComplementoEstudanteComponent,
    },
    {
        path: "certificado/validar/:idParticipacaoSessao",
        component: ValidarCertificadoComponent,
    },

    {
        path: "",
        loadChildren: () => import("./pages/pages.module").then(m => m.PagesModule),
        canActivate: [AuthGuard],
    },
    { path: "**", redirectTo: "" },
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forRoot(routes)],
    providers: [],
})
export class AppRoutingModule {}
